// extracted by mini-css-extract-plugin
export default {"mainContainer":"SilencingPage_mainContainer__RcA0U","silencingPage":"SilencingPage_silencingPage__AU4Xx"};